import { getApiErrorMessage } from './apiError';
import {
  STATUS_UPDATE_SUCCESS_MESSAGE,
  validateStatusUpdate,
} from './statusUpdateValidation';
import { statusRequiresInterviewDate } from './candidateStatus';
import { showError, showSuccess } from './toast';

export async function submitStatusUpdate({
  api,
  candidateId,
  selectedStatus,
  statusRemark,
  statusInterviewDate,
  updatedBy,
  onSuccess,
}) {
  const validation = validateStatusUpdate({
    selectedStatus,
    statusRemark,
    statusInterviewDate,
  });

  if (!validation.ok) {
    showError(validation.message);
    return false;
  }

  try {
    const payload = {
      status: selectedStatus,
      remark: String(statusRemark).trim(),
      updatedBy: updatedBy || undefined,
    };

    if (statusRequiresInterviewDate(selectedStatus)) {
      payload.interviewDate = statusInterviewDate;
    }

    const response = await api.put(`/updatestatus/${candidateId}`, payload);
    showSuccess(STATUS_UPDATE_SUCCESS_MESSAGE);
    if (onSuccess) await onSuccess(response.data);
    return response.data;
  } catch (error) {
    showError(getApiErrorMessage(error, 'Failed to update status. Please try again.'));
    return false;
  }
}
